/**
 *  Returns string with periods between characters; for name initials
 */
const nameLetters = (letters: string) => {
	if (letters === null) return '';
	return letters.split('').join('.') + '.';
};

export default nameLetters;
